/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `text` - text
 * * `file` - file
 * @export
 */
export const FieldTypeEnum = {
  text: 'text',
  file: 'file',
} as const;
export type FieldTypeEnum = (typeof FieldTypeEnum)[keyof typeof FieldTypeEnum];

export function instanceOfFieldTypeEnum(value: any): boolean {
  for (const key in FieldTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(FieldTypeEnum, key)) {
      if ((FieldTypeEnum as Record<string, FieldTypeEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function FieldTypeEnumFromJSON(json: any): FieldTypeEnum {
  return FieldTypeEnumFromJSONTyped(json, false);
}

export function FieldTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldTypeEnum {
  return json as FieldTypeEnum;
}

export function FieldTypeEnumToJSON(value?: FieldTypeEnum | null): any {
  return value as any;
}
